	module.exports = (function() {
	window.initiatedFormInit = function (formArray, eventCategory) {
		$.each(formArray, function(i, oFormName){
			$('#' + oFormName + ' :input').not("[type=hidden]").each(function(j, oFormEle){
				if ($.inArray(oFormEle.type, ['text', 'textarea']) != -1) {
					$(oFormEle).bind('keyup.GDLPush', function(){
						if (this.value.length >= 4) {
							initiatedForm(eventCategory,oFormName);
						}
					});
				} else {
					$(oFormEle).bind('change.GDLPush', function(){
						initiatedForm(eventCategory,oFormName);
					});
				}
			});
		});
	};
	
	//Global GAPush - Purpose : in case google decides to change the function/method of the GTM push
	window.GAPush = function(oPushedEle){
		var oPushedElelCase = {};
		var key,value;

		/* Set all the values of the object in lower case */
		$.each(oPushedEle, function(key,value){
			if (typeof value === 'string') {
				oPushedElelCase[key] = value.toLowerCase();
			} else {
				oPushedElelCase[key] = value;				
			}
		})
		
		dataLayer.push(oPushedElelCase);		
	};

	window.initiatedActiveCampaignFormInit = function(ExternalIntegrationCode,FormID){
		dataLayerPushValue = {
			event : 'ACform',
			eventAction : 'initiated',
			eventCategory : ExternalIntegrationCode + '_' + FormID,
			eventLabel : dataLayerEle.campus
		}	
		
		GAPush(dataLayerPushValue);	
	};


})();

function initiatedForm(eventCategory, oFormName){
	dataLayerPushValue = {
		event : 'form',
		eventAction : 'initiated',
		eventCategory : eventCategory,
		eventLabel : dataLayerEle.campus
	}
	
	if(oFormName !== undefined){
		dataLayerPushValue.eventFormName = oFormName;
	}
	
	GAPush(dataLayerPushValue);
	
	$('#'+oFormName+' :input').unbind(".GDLPush");
};
